import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from "vue";
import AutoAddress from "./auto-address.vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { Address } from "@/types/generic/Address";


export default /*#__PURE__*/_defineComponent({
  __name: 'auto-address-wrapper',
  emits: ["onAddressFound", "onSearchCompleted"],
  setup(__props, { emit }) {

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;



const onAddressFound = async (e: any) => {
  // Nothing found so quit to prevent api errors
  if (!e?.addressId) {
    return;
  }

  // Call api to reformat the selected address to avoid duplicating the logic
  const address = await apiClient.httpPost<Address>(
    "app/utilityswitching/addresslookup/format",
    e,
  );

  emit("onAddressFound", address);
};

const onSearchCompleted = () => {
  emit("onSearchCompleted");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AutoAddress, {
    licencekey: "67EC65D2-7228-BEED-4EC5-2087E8E0F39A",
    "vanity-mode": true,
    "address-profile": "Demo5LineV3",
    onOnAddressFound: onAddressFound,
    onOnSearchCompleted: onSearchCompleted,
    addressFoundLabel: "Success! The property was found.",
    placeHolderLabel: "",
    inputRequiredLabel: "Enter a full address or eircode to begin your search.",
    noEircodeAppendedLabel: "Address found, but no eircode available",
    nuaAddressFoundLabel: "We've found the address, please add your eircode in the text box below if you know it"
  }))
}
}

})